<template>
  <Teleport to="body">
    <transition-group name="transition--fade" tag="div">
      <div
        v-for="(modal, i) in modals"
        :key="modal.id"
        ref="modal"
        class="modal"
        tabindex="0"
        role="dialog"
        @mousedown.self="handleClose(modal.id)"
      >
        <div
          class="container flex justify-center items-center h-full"
          @mousedown.self="handleClose(modal.id)"
        >
          <component
            :is="modal.component"
            v-bind="modal.props"
            :style="{ 'z-index': 2000 + i }"
            @close="(e) => handleClose(modal.id, e)"
          />
        </div>
      </div>
    </transition-group>
  </Teleport>
</template>

<script setup>
const emits = defineEmits(['close'])

defineProps({
  modals: {
    type: Array,
    default: () => []
  }
})

function handleClose(modalId, result) {
  emits('close', modalId, result)
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>
